import { Product } from '@model/product';

export const getGender = (product: Product) => (product.customAttrArray || []).find(({ name }) => name === 'gender')
